import { ReactElement } from "react";

export function ArrowRight(): ReactElement {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="currentColor"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.41066 3.57745C9.7361 3.25201 10.2637 3.25201 10.5892 3.57745L16.4225 9.41079C16.7479 9.73622 16.7479 10.2639 16.4225 10.5893L10.5892 16.4226C10.2637 16.7481 9.7361 16.7481 9.41066 16.4226C9.08523 16.0972 9.08523 15.5696 9.41066 15.2441L13.8214 10.8334H4.16659C3.70635 10.8334 3.33325 10.4603 3.33325 10C3.33325 9.5398 3.70635 9.16671 4.16659 9.16671H13.8214L9.41066 4.75596C9.08523 4.43053 9.08523 3.90289 9.41066 3.57745Z"
            />
        </svg>
    );
}
